var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcNewPost(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "75p26lpi4a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95FFF6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C88FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52.296%",
    y1: "100%",
    x2: "47.704%",
    y2: "0%",
    id: "v9hbw0k14b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95FFF6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C88FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "52.296%",
    x2: "0%",
    y2: "47.704%",
    id: "69d4kldd1c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95FFF6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C88FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "82.766%",
    y1: "100%",
    x2: "17.234%",
    y2: "0%",
    id: "xce2o4skrd"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95FFF6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C88FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50.93%",
    x2: "0%",
    y2: "49.07%",
    id: "h5xjsmlnne"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95FFF6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C88FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "53.125%",
    x2: "0%",
    y2: "46.875%",
    id: "iorg0etf8f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95FFF6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C88FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.708 38c-5.674 0-10.291-4.617-10.291-10.292 0-5.674 4.617-10.291 10.291-10.291C33.383 17.417 38 22.034 38 27.708 38 33.383 33.383 38 27.708 38zm0-18.208c-4.365 0-7.916 3.551-7.916 7.916 0 4.366 3.551 7.917 7.916 7.917 4.366 0 7.917-3.551 7.917-7.917 0-4.365-3.551-7.916-7.917-7.916z",
    fill: "url(#75p26lpi4a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.708 33.25a1.188 1.188 0 0 1-1.187-1.188v-8.708a1.188 1.188 0 0 1 2.375 0v8.709c0 .655-.532 1.187-1.188 1.187z",
    fill: "url(#v9hbw0k14b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.063 28.896h-8.709a1.188 1.188 0 0 1 0-2.375h8.709a1.188 1.188 0 0 1 0 2.375z",
    fill: "url(#69d4kldd1c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.55 33.25H4.355A4.358 4.358 0 0 1 0 28.896V4.354A4.358 4.358 0 0 1 4.354 0h18.209a4.358 4.358 0 0 1 4.354 4.354v9.643a1.188 1.188 0 0 1-2.375 0V4.354c0-1.09-.889-1.979-1.98-1.979H4.355c-1.09 0-1.979.888-1.979 1.98v24.54c0 1.092.888 1.98 1.98 1.98H14.55a1.188 1.188 0 0 1 0 2.375z",
    fill: "url(#xce2o4skrd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.98 15.042H5.936a1.188 1.188 0 0 1 0-2.375H20.98a1.188 1.188 0 0 1 0 2.375z",
    fill: "url(#h5xjsmlnne)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.646 21.375H5.937a1.188 1.188 0 0 1 0-2.375h8.709a1.188 1.188 0 0 1 0 2.375z",
    fill: "url(#69d4kldd1c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.063 8.708H5.936a1.188 1.188 0 0 1 0-2.375h7.125a1.188 1.188 0 0 1 0 2.375z",
    fill: "url(#iorg0etf8f)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNewPost);
export default __webpack_public_path__ + "static/media/ic_new_post.a50821a34481884d8df32e864399c112.svg";
export { ForwardRef as ReactComponent };